<template>
  <div class="ticket-container">
    <el-select
      v-model="typeId"
      placeholder="请选择单据类型"
      @change="handelTypeChange"
      style="width: 200px;margin-bottom: 20px;">
      <el-option
        v-for="item in typeList"
        :disabled="!typeHead.find(head => head.typeId === item.id)"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>

    <div class="mb20">
      <el-button type="primary" v-if="columns.length" @click="handleAdd">新增</el-button>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="typeId ? tableData.filter(item => item.ticketType === typeId) : []"
      border
      style="width: 100%">
      <el-table-column
        v-for="col in columns"
        align="center"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :width="col.width"/>
      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <!-- 删除按钮暂时隐藏 -->
          <el-button
            v-if="false"
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="30%">
      <el-form :model="formData" label-width="80px">
        <el-form-item
          v-for="col in cloumns"
          :key="col.prop"
          :label="col.label">
          <el-input v-model="formData[col.prop]"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import requestTicket from '@/utils/requestTicket'

export default {
  name: 'Ticket',
  data() {
    return {
      columns:[],
      tableData: [],
      dialogVisible: false,
      dialogTitle: '新增',
      formData: {},
      typeList: [],
      typeHead: [],
      typeId: null
    }
  },
  mounted() {
    this.fetchData()
    this.getTypeHead()
    this.getTypeList()
  },
  methods: {
    // 获取数据列表
    async fetchData() {
      try {
        const res = await requestTicket.post('/Ticketing/ticket/findAll')
        this.tableData = res.data
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },
    async getTypeList() {
      try {
        const res = await requestTicket.post('/Ticketing/ticket-type/findAll')
        this.typeList = res.data
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },
    async getTypeHead() {
      try {
        const res = await requestTicket.post('/Ticketing/ticket-head/findAll')
        this.typeHead = res.data
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },
    handelTypeChange() {
      this.formData.ticketType = this.typeId
      this.columns = this.typeHead.filter(item => item.typeId === this.typeId)
    },
    // 新增操作
    handleAdd() {
      this.formData = {
        ticketType : this.typeId
      }
      this.dialogTitle = '新增'
      this.dialogVisible = true
    },

    // 编辑操作
    handleEdit(row) {
      this.formData = { ...row }
      this.dialogTitle = '编辑'
      this.dialogVisible = true
    },

    // 提交表单
    async submitForm() {
      try {
        await requestTicket.post('/Ticketing/ticket/save', this.formData)
        this.$message.success('操作成功')
        this.dialogVisible = false
        this.fetchData()
      } catch (error) {
        console.error('操作失败:', error)
        this.$message.error('操作失败')
      }
    },

    // 删除操作（暂时隐藏）
    async handleDelete(id) {
      try {
        await requestTicket.delete(`/Ticketing/ticket/${id}`)
        this.$message.success('删除成功')
        this.fetchData()
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error('删除失败')
      }
    }
  }
}
</script>

<style scoped>
.ticket-container {
  padding: 20px;
}
.mb20 {
  margin-bottom: 20px;
}
</style>